module.exports = __webpack_public_path__ + "img/es.94cdc018.png";